import request from './request';
import deserialize from './deserialize';

type Image = {
  id: string;
  versions: {
    sm: string;
    md: string;
    lg: string;
    xl: string;
  };
};

export type Reward = {
  id: string;
  createdAt: number;
  gift: boolean;
  info: string;
  sell: boolean;
  title: string;
  updatedAt: number;
  what: string;
  images?: Image;
};

export function get(companyId: string, rewardId: string) {
  return request<Reward>({
    url: `/companion/v1/companies/${companyId}/rewards/${rewardId}`,
    method: 'GET',
    transformResponse: deserialize,
  });
}
